// Central export for all Zustand stores
// This file provides a single entry point for importing stores

// Core stores
export { 
  useAuthStore, 
  initAuthStore, 
  setupActivityTracking 
} from './authStore';

export { 
  useWebSocketStore, 
  startConnectionHealthCheck, 
  stopConnectionHealthCheck,
  useMonitoringData,
  useCalibrationUpdates,
  useSessionUpdates,
  useExamUpdates
} from './websocketStore';

export { 
  useExamStore, 
  formatTime, 
  getTimeColor, 
  getTimeWarning,
  cleanupExamStore 
} from './examStore';

export { 
  useMonitoringStore,
  getAlertSeverity,
  getAlertColor,
  analyzeMonitoringTrends,
  getCalibrationProgress
} from './monitoringStore';

export { 
  useInstructorStore,
  cleanupInstructorStore,
  getStudentStatusColor,
  getStudentRiskLevel,
  formatLastActivity
} from './instructorStore';

export { 
  useUIStore, 
  initUIStore, 
  setupKeyboardShortcuts,
  applyDocumentTheme,
  resolveColorMode,
  type ColorMode,
  type ResolvedTheme,
} from './uiStore';

// Import the function directly to ensure it's available
import { initAuthStore } from './authStore';
import { initUIStore } from './uiStore';

// Store initialization utility
export const initializeStores = () => {
  console.log('Initializing QuizSecure stores...');
  
  // Initialize auth store only once on app startup
  try {
    initAuthStore();
    console.log('Auth store initialized successfully');
  } catch (error) {
    console.error('Failed to initialize auth store:', error);
  }

  const cleanupUI = initUIStore();
  
  console.log('All stores ready for initialization');
  
  // Return cleanup function
  return () => {
    cleanupUI();
    console.log('Store cleanup completed');
  };
};

// Type exports for convenience
export type {
  User,
  Session,
  ExamQuestion,
  ExamData,
  MonitoringResult,
  CalibrationInfo,
  StudentSessionInfo,
  WebSocketMessage,
  APIResponse,
  AuthResponse,
  ExamSubmissionResponse,
  AlertLevel,
  GazeData,
  HeadPose,
  BehavioralFlags
} from '@/types';